import api from '@/api/sapi.js'
import { getSignupTemplate, historyQueryById } from '@/api/saiti'

function handleError(error, redirect) {
  console.error(error || '请求失败')
}

// HTML实体解码函数（从组件中复制）
function decodeHtmlEntities(content) {
  if (!content || typeof content !== 'string') {
    return content
  }

  let decoded = content

  try {
    // 直接解码常见的JSON转义序列
    if (decoded.includes('\\u003C') || decoded.includes('\\u002F') || decoded.includes('\\"')) {
      const jsonReplacements = {
        '\\u003C': '<',
        '\\u003E': '>',
        '\\u002F': '/',
        '\\u0026': '&',
        '\\u0022': '"',
        '\\u0027': "'",
        '\\u003D': '=',
        '\\u0020': ' ',
        '\\u000A': '\n',
        '\\u000D': '\r',
        '\\u0009': '\t'
      }
      Object.keys(jsonReplacements).forEach(encoded => {
        if (decoded.includes(encoded)) {
          decoded = decoded.replace(new RegExp(encoded, 'g'), jsonReplacements[encoded])
        }
      })
    }

    // 解码Unicode转义序列（\uXXXX格式）
    decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
      return String.fromCharCode(parseInt(code, 16))
    })

    // 解码其他类型的转义序列
    decoded = decoded.replace(/\\n/g, '\n')
    decoded = decoded.replace(/\\t/g, '\t')
    decoded = decoded.replace(/\\r/g, '\r')
    decoded = decoded.replace(/\\"/g, '"')
    decoded = decoded.replace(/\\'/g, "'")
    decoded = decoded.replace(/\\\\/g, '\\')

    // 手动解码常见的HTML实体
    const htmlEntities = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'",
      '&#x27;': "'",
      '&#x2F;': '/',
      '&#x60;': '`',
      '&#x3D;': '=',
      '&nbsp;': ' ',
      '&#13;': '\r',
      '&#10;': '\n'
    }

    Object.keys(htmlEntities).forEach(entity => {
      if (decoded.includes(entity)) {
        decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
      }
    })
  } catch (error) {
    console.error('decodeHtmlEntities: Error during decoding:', error)
    decoded = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
      return String.fromCharCode(parseInt(code, 16))
    })
  }

  return decoded
}

export default {
  async getSaitiInfo({ commit, state }, params) {
    try {
      const data = await api.getSaitiInfo(params, state.currentLanguge)
      commit('getSaitiInfo', data)
      return data
    } catch (error) {
      handleError(error)
    }
  },

  async getNewsInfo({ commit, state }, params) {
    try {
      const data = await api.getNewsInfo(params, state.currentLanguge)
      commit('getNewsInfo', data)
    } catch (error) {
      handleError(error)
    }
  },

  // 新增：获取比赛的articles数据（用户协议和参赛须知）
  async getCompetitionArticles({ commit, state }, { competitionId, templateId, signup }) {
    try {
      const articles = []

      if (signup === '04') {
        // 已结束的比赛，使用历史查询
        const param = `competitionId=${competitionId}`
        const response = await historyQueryById(param)

        if (response.success) {
          // 添加协议数据
          if (response.result.agreementId && response.result.agreementContext) {
            articles.push({
              id: response.result.agreementId,
              title: '用户协议', // 这里先用固定值，后续可以根据语言动态获取
              content: decodeHtmlEntities(response.result.agreementContext),
              type: 'agreement'
            })
          }

          // 添加通知数据
          if (response.result.noticeId && response.result.noticeContext) {
            articles.push({
              id: response.result.noticeId,
              title: '参赛须知',
              content: decodeHtmlEntities(response.result.noticeContext),
              type: 'notice'
            })
          }
        }
      } else if (templateId) {
        // 正常比赛，使用模板查询
        const param = `templateId=${templateId}`
        const response = await getSignupTemplate(param)

        if (response.success) {
          // 添加协议数据
          if (response.result.agreementId && response.result.agreementContent) {
            articles.push({
              id: response.result.agreementId,
              title: '用户协议',
              content: decodeHtmlEntities(response.result.agreementContent),
              type: 'agreement'
            })
          }

          // 添加通知数据
          if (response.result.noticeId && response.result.noticeContent) {
            articles.push({
              id: response.result.noticeId,
              title: '参赛须知',
              content: decodeHtmlEntities(response.result.noticeContent),
              type: 'notice'
            })
          }
        }
      }

      commit('setArticles', articles)
      return articles
    } catch (error) {
      console.error('获取articles数据失败:', error)
      commit('setArticles', [])
      return []
    }
  }
}
